"use client";

import { useState } from "react";
import CouponGridCard from "./CouponGridCard";

/** Only what a card renders: this array is serialised into the page, so it must stay small. */
export interface CategoryCouponData {
    id: string;
    title: string;
    storeId: string;
    type: string;
    discountValue: number | null;
    discountType: "PERCENT" | "FIXED" | "FREE_SHIPPING" | "DEAL" | null;
    verified: boolean;
    store: { name: string; slug: string; logo: string | null; anchorSuffix: string };
}

export default function CategoryCouponGrid({ coupons, title, referral = false }: { coupons: CategoryCouponData[], title?: string, referral?: boolean }) {
    const [visibleCount, setVisibleCount] = useState(12);

    const visibleCoupons = coupons.slice(0, visibleCount);
    const hasMore = coupons.length > visibleCount;

    return (
        <section className="max-w-6xl mx-auto px-4 py-6 w-full">
            <h2 className="cs-section-title text-center">{title || `${coupons.length} Active Deals`}</h2>
            <div className="cs-offer-grid">
                {visibleCoupons.map((coupon) => (
                    <CouponGridCard
                        key={coupon.id}
                        id={coupon.id}
                        title={coupon.title}
                        storeName={coupon.store.name}
                        storeSlug={coupon.store.slug}
                        storeId={coupon.storeId}
                        storeLogo={coupon.store.logo ?? undefined}
                        type={coupon.type}
                        discountValue={coupon.discountValue}
                        discountType={coupon.discountType}
                        verified={coupon.verified}
                        anchorSuffix={referral ? "referral code" : coupon.store.anchorSuffix}
                        pagePath={referral ? `/${coupon.store.slug}/referral-code` : undefined}
                    />
                ))}
            </div>

            {hasMore && (
                <div className="mt-10 text-center">
                    <button
                        type="button"
                        onClick={() => setVisibleCount((prev) => prev + 12)}
                        className="cs-btn cs-btn--accent"
                    >
                        Load More Deals
                    </button>
                </div>
            )}
        </section>
    );
}
